export enum SearchDeadLetterFilters {
    CorrelationId = 'correlationId',
    MessageType = 'MessageType',
}